import type { FC, PropsWithChildren } from 'react';
import { createContext, useContext } from 'react';

interface ButtonDisabledContextProviderProps extends PropsWithChildren {
  disabled: boolean | undefined;
}

const ButtonDisabledContext = createContext<boolean | undefined>(undefined);

export const ButtonDisabledContextProvider: FC<ButtonDisabledContextProviderProps> = ({ children, disabled }) => (
  <ButtonDisabledContext.Provider value={disabled}>{children}</ButtonDisabledContext.Provider>
);

export const useButtonDisabledContext = (): boolean | undefined => useContext(ButtonDisabledContext);
